import OfflineNotificationModal from './OfflineNotificationModal';

export default OfflineNotificationModal;
